import classNames from "classnames/bind";
import React from "react";
import { Icon } from "../Icon";
import { Skeleton } from "../Skeleton";
import styles from "./Breadcrumbs.module.scss";
import type { BreadcrumbProps } from "./types";

const cx = classNames.bind(styles);

const Breadcrumb = ({
  title,
  href,
  onClick,
  isLastBreadcrumb = false,
  isLoading,
}: BreadcrumbProps) => {
  const clickable = !isLastBreadcrumb && (href || onClick);

  return (
    <li
      key={title}
      role="breadcrumb"
      className={cx("item", isLastBreadcrumb ? "item--last" : "")}
      aria-current={isLastBreadcrumb}
    >
      <span className={cx("content")}>
        <Skeleton
          isLoading={isLoading}
          className={cx("content-skeleton")}
        >
          {clickable ? (
            <a
              className={cx("link")}
              onClick={(evt) => {
                if (!onClick) {
                  return;
                }

                evt.preventDefault();
                onClick(evt);
              }}
              href={href}
            >
              {title}
            </a>
          ) : (
            <p className={cx("text")}>{title}</p>
          )}
        </Skeleton>

        {!isLastBreadcrumb ? (
          <div className={cx("iconSeparation")}>
            <Icon
              variant="caret-right"
              weight="regular"
              size={16}
            />
          </div>
        ) : null}
      </span>
    </li>
  );
};

export default Breadcrumb;
